import { env } from '@/helpers/env'

export const config = {
  enabled: env('VUE_APP_SENTRY_ENABLED', false) && !!env('VUE_APP_SENTRY_DNS'),
  dns: env('VUE_APP_SENTRY_DNS', null),
  rate: parseFloat(env('VUE_APP_SENTRY_TRACES_SAMPLE_RATE', 1)),
}
